import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Row, Input, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import PassengersreviewDetail from '../../components/review/PassengersreviewDetail';
import { connect } from "react-redux";
import BusSteppers from "./busSteppers";
import PriceFormatter from '../../components/misc/PriceFormatter';
import * as moment from 'moment';
import 'moment-timezone';
import { API_URL } from "../../config/Config";
import axios from "axios";
import qs from 'qs';
import axiosRetry from 'axios-retry';
import { ACCESS_TOKEN } from "../../redux/actions/setting";
import { setReserve, setBusIssue } from "../../redux/actions/ticket";
import SaveLoader from "../../components/loader/SaveLoader";
import BusItemDetail from "./BusItemDetail";
import { ALL_BUS_STATIONS } from "./BusConfig"

axiosRetry(axios, { retries: 3 });


class BusTicketreview extends Component {
    constructor(props) {
        super(props);
        const total = (Number(this.props.busticket.BusTicket.totalPrice) * Number(this.props.bususer.BusPassenger.seats.length)) + ((Number(this.props.busticket.BusTicket.totalPrice) * Number(this.props.bususer.BusPassenger.seats.length)) * .06);
        this.state = {
            loading: false, plzlogin: false, cupon: 0,
            discunt: { discount_amount: 0, discount_percent: 0 },
            finaldiscount: 0,
            total_price: total,
            review: [],
            fee: Number(this.props.busticket.BusTicket.totalPrice) * .06,
            price: (Number(this.props.busticket.BusTicket.totalPrice) * Number(this.props.bususer.BusPassenger.seats.length))
        }
        this.handelConfirm = this.handelConfirm.bind(this);

    }
    componentDidMount() {
        const userlogin = JSON.parse(JSON.parse(localStorage["persist:root"]).user)
        if (localStorage.length !== 0 && userlogin.apiToken !== null) {
            this.setState({ plzlogin: true });
        } else {
            this.setState({ plzlogin: false })
        }
    }
    async handelConfirmCupon() {
        this.setState({ loading: true });
        console.log(this.state.cupon)
        const options = {
            method: 'GET',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                // 'X-ZUMO-AUTH': access_token,
                // 'Content-Type': 'application/json',
            },
            // data: qs.stringify(reserve),
            url: API_URL + 'coupon-code/' + this.state.cupon,
        };

        let get_discont = await axios(options);
        if (get_discont.status < 200 || get_discont.status > 300) {
            const error = new Error(get_discont.statusText);
            error.get_discont = get_discont;
            console.log(error);
        } else {
            const review = Number(this.state.price);
            const persent = Number(get_discont.data.data.discount_percent / 100);
            const amount = Number(get_discont.data.data.discount_amount);
            const finaldiscount = (review * persent) + amount;
            const total_price = (review - (review * persent)) - amount;
            const fee = total_price * .06
            // const finaldiscount = amount;
            // console.log(persent)
            // console.log(amount)
            // console.log(review * persent)
            // console.log(finaldiscount)
            this.setState({
                fee,
                finaldiscount
                , total_price: total_price + fee
                , loading: false
            });
        }
    }

    async handelConfirm() {
        if (this.props.user.email === 'info@mehdisaedi.com') {
            console.log('adminessssssssssss');

            this.setState({ loading: true })
            const { busticket, bususer } = this.props;
            const passenger = bususer.BusPassenger.passenger;
            const seats = bususer.BusPassenger.seats;
            const user = bususer.BusPassenger.user;
            const rph = busticket.BusTicket.rph;
            const access_token = localStorage.getItem(ACCESS_TOKEN);
            let data = {
                "adultNo": seats.length,
                "childNo": 0,
                "infantNo": 0,
                "passengers": [{
                    "FirstName": passenger.name,
                    "LastName": passenger.family,
                    "NationalIdentification": passenger.DocIssuedCountry === "IR" ? passenger.nationalId : passenger.passportId,
                    "Gender": passenger.Gender === 1 ? "male" : "female",
                    "BirthDate": passenger.BirthDate,
                    "DocIssuedCountry": passenger.DocIssuedCountry,
                    "DocType": passenger.DocType,
                    "PassengerType": passenger.PassengerType,
                    "family": passenger.family,
                    "name": passenger.name,
                    "nationalId": passenger.nationalId,
                    "passportExpire": passenger.passportExpire,
                    "passportId": passenger.passportId,
                    "id": null
                }],
                "Rph": rph,
                "altrabo_token": access_token,
                "selected_seats": seats
            }
            if (this.state.plzlogin === false) {
                console.log(user);
                const users = {
                    "email": user.email,
                    "cell_phone": user.mobile,
                    "tel": user.tel,
                    "whatsapp": user.whatsapp
                };
                data.user = users;
            } else {
                data.api_token = user.api_token;
            }

            console.log(' ---data----');
            console.log(data);

            const options = {
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(data),
                url: API_URL + 'bus-ticket-register',
            };
            let response;

            try {
                response = await axios(options);
                console.log(response);
                this.setState({ loading: false })
                const reserve = {
                    "user_id": response.data.data.user.id,
                    "altrabo_token": access_token,
                    "ExternalBookIds": response.data.reserveRequestId,
                    "user_ticket_id": response.data.data.id,
                    "ticket_type": "bus"
                }
                console.log(reserve)
                this.props.setReserve(reserve);
                this.props.setBusIssue(response.data);
                alert("Attention Your Ticket is Issue with Admin User you can download it in next page");
                window.location.replace("/Paymentgetway");
            } catch (err) {
                this.setState({ loading: false })
                console.log("err.response");
                console.log(err);
                console.log(err.response);
                alert(err.response.data.message);
                // window.location.replace("/search-bus");
            }
        } else {
            this.setState({ loading: true })
            const { busticket, bususer } = this.props;
            const passenger = bususer.BusPassenger.passenger;
            const seats = bususer.BusPassenger.seats;
            const user = bususer.BusPassenger.user;
            const rph = busticket.BusTicket.rph;
            const access_token = localStorage.getItem(ACCESS_TOKEN);
            let data = {
                "adultNo": seats.length,
                "childNo": 0,
                "infantNo": 0,
                "passengers": [{
                    "FirstName": passenger.name,
                    "LastName": passenger.family,
                    "NationalIdentification": passenger.DocIssuedCountry === "IR" ? passenger.nationalId : passenger.passportId,
                    "Gender": passenger.Gender === 1 ? "male" : "female",
                    "BirthDate": passenger.BirthDate,
                    "DocIssuedCountry": passenger.DocIssuedCountry,
                    "DocType": passenger.DocType,
                    "PassengerType": passenger.PassengerType,
                    "family": passenger.family,
                    "name": passenger.name,
                    "nationalId": passenger.nationalId,
                    "passportExpire": passenger.passportExpire,
                    "passportId": passenger.passportId,
                    "id": null
                }],
                "Rph": rph,
                "altrabo_token": access_token,
                "selected_seats": seats
            }
            if (this.state.plzlogin === false) {
                console.log(user);
                const users = {
                    "email": user.email,
                    "cell_phone": user.mobile,
                    "tel": user.tel,
                    "whatsapp": user.whatsapp
                };
                data.user = users;
            } else {
                data.api_token = user.api_token;
            }

            console.log(' ---data----');
            console.log(data);

            const options = {
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(data),
                url: API_URL + 'bus-ticket-register',
            };
            let response;

            try {
                response = await axios(options);
                console.log(response);
                this.setState({ loading: false })
                const reserve = {
                    "user_id": response.data.data.user.id,
                    "altrabo_token": access_token,
                    "ExternalBookIds": response.data.reserveRequestId,
                    "user_ticket_id": response.data.data.id,
                    "ticket_type": "bus"
                }
                console.log(reserve)
                this.props.setReserve(reserve);
                alert("Attention Your Ticket has been reserved by us. You have 10 minutes to Pay it.")
                window.location.replace("/Paymentgetway");
            } catch (err) {
                this.setState({ loading: false })
                console.log("err.response");
                console.log(err);
                console.log(err.response);
                alert(err.response.data.message);
                // window.location.replace("/search-bus");
            }
        }




    }
    handleChange(e) {
        this.setState({ cupon: e.target.value })
    }

    render() {
        const { bususer, busticket } = this.props;
        // console.log(busticket)
        // console.log(bususer)


        const passenger = bususer.BusPassenger.passenger;
        const seats = bususer.BusPassenger.seats;
        const review = busticket.BusTicket;
        const arrivalDate = busticket.BusTicket.departureDateTime;
        const orgin = ALL_BUS_STATIONS.filter(i => i.value === busticket.BusTicket.orginStationCode)[0].label
        const destination = ALL_BUS_STATIONS.filter(i => i.value === busticket.BusTicket.destinationStationCode)[0].label;
        // console.log(this.props.busticket.BusTicket.totalPrice)
        // console.log(passenger)
        return (
            <div className="Ticketreview pt-5 mt-5">
                {this.state.loading === true && <SaveLoader type="spinningBubbles" color="#43b185" />}
                <Container className="min-height-500">
                    <Breadcrumb className='w-100 white mt-3'>
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Ticket Review</BreadcrumbItem>
                    </Breadcrumb>
                    <Row>
                        <Col >
                            <div className="white box search-progress">
                                <BusSteppers active={2} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Ticket Information</h4>
                        </Col>
                        <Col md='12' sm='12' >
                            <BusItemDetail item={review} orgin={orgin}
                                destination={destination}
                                seats={seats}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Passengers Information</h4>
                        </Col>
                        <Col md='12' sm='12' >
                            <PassengersreviewDetail data={[passenger]} />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Invoice Summary</h4>
                        </Col>

                        <Card className="white mb-3 w-100 flight-item tick-rew-card">
                            <CardBody>
                                <Col md='12' sm='12' >
                                    <span className="coupan-span" >
                                        Coupan Code :
                                    </span>
                                    <Input
                                        // invalid={("passportId" in errors)}
                                        name="Coupan-Code"
                                        type="text"
                                        placeholder="Coupan Code"
                                        // value={fields.passportId}
                                        onChange={this.handleChange.bind(this)}
                                        // onBlur={this.handleBlur.bind(this)}
                                        className=" coupan-input"
                                    />
                                    <Button className="Coupan-submit"
                                        onClick={this.handelConfirmCupon.bind(this)}
                                    >
                                        Submit
                                    </Button>
                                </Col>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row>
                        <Card className="white mb-3 w-100 flight-item tick-rew-card">
                            <CardBody>
                                <Col className='price-review-col' md='12' sm='12'>
                                    <p>
                                        <span className='price-review'>
                                            Price :
                                        </span>
                                        <span className='price-review-content'>
                                            {/* {console.log(this.state.price)} */}
                                            <PriceFormatter
                                                className="item-price"
                                                data={this.state.price}
                                                type="airplane"
                                                date={moment(arrivalDate).format("YYYY-MM-DD")}
                                            />
                                        </span>
                                    </p>
                                </Col>
                                <Col className='price-review-col' md='12' sm='12'>
                                    <p>
                                        <span className='price-review'>
                                            Discount :
                                        </span>
                                        <span className='price-review-content'>
                                            {/* {review.discount !== null ? review.discount : '0'} */}
                                            <PriceFormatter
                                                className="item-price"
                                                data={this.state.finaldiscount}
                                                type="airplane"
                                                date={moment(arrivalDate).format("YYYY-MM-DD")}
                                            />
                                        </span>
                                    </p>
                                </Col>
                                <Col className='price-review-col-end' md='12' sm='12'>
                                    <p>
                                        <span className='price-review'>
                                            6% Service Fee :
                                        </span>
                                        <span className='price-review-content'>

                                            <PriceFormatter
                                                className="item-price"
                                                data={this.state.fee}
                                                type="airplane"
                                                date={moment(arrivalDate).format("YYYY-MM-DD")}
                                            />
                                        </span>
                                    </p>
                                </Col>
                                <Col className='price-review-col-end' md='12' sm='12'>
                                    <p>
                                        <span className='price-review'>
                                            Total Price :
                                        </span>
                                        <span className='price-review-content'>
                                            <PriceFormatter
                                                className="item-price"
                                                data={this.state.total_price}
                                                type="airplane"
                                                date={moment(arrivalDate).format("YYYY-MM-DD")}
                                            />
                                        </span>
                                    </p>
                                </Col>
                            </CardBody>
                        </Card>
                    </Row>

                    <Button className="agree-and-go" onClick={this.handelConfirm} >
                        {/* <Link to="/sales-invoice"> */}
                        Confirm informations
                        {/* </Link> */}
                    </Button>
                </Container>
            </div >
        )
    }

}
const mapStateToProps = (state) => {
    return {
        busticket: state.busticket,
        bususer: state.bususer,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setReserve: (reserve) => {
            dispatch(setReserve(reserve))
        },
        setBusIssue: (reserve) => {
            dispatch(setBusIssue(reserve))
        },
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(BusTicketreview)



// WEBPACK FOOTER //
// ./src/containers/bus/BusTicketReview.jsx